import { useField, ErrorMessage } from "formik";
import '../styles/contactError.css'

export const TextField = ({label, ...props}) => {

    const [field, meta] = useField(props);  
      
    return (
            <div>
                <label htmlFor={field.name}>{label}</label>
                <input className={`form-control shadow-none ${meta.touched && meta.error && 'is-invalid'}`}  
                    autoComplete="off" {...field}{...props}/>
                <ErrorMessage component="div" className="error" name={field.name} />
            </div>
    )
}

export const TextArea = ({label, ...props}) => {

    const [field, meta] = useField(props);

    return (
    
        <div>
            <label htmlFor={field.name}>{label}</label>
            <textarea className={`form-control shadow-none ${meta.touched && meta.error && 'is-invalid'}`} 
                 autoComplete="off" {...field}{...props}/>
            <ErrorMessage component="div" name={field.name} className="error" />
           
        </div>
        
    )
}

